import React from 'react'
import styled from 'styled-components'

import { Fonts } from 'components/base-ui'
import Profile from 'components/dine-in/Profile'
import GlobalCartItemList from 'components/dine-in/GlobalCartItemList'
import type { GlobalCart } from 'hooks/useGlobalCart'
import { useTranslation } from 'react-i18next'

import { displayTimeByLang } from 'helpers/dateTime'

interface GlobalCartLineItemProps {
  globalCart: GlobalCart
  noPadding?: boolean
  noBorderTop?: boolean
  buffetPackageName?: string
}

const GlobalCartLineItem = ({ globalCart, noPadding, noBorderTop, buffetPackageName }: GlobalCartLineItemProps) => {
  const {
    i18n: { language },
  } = useTranslation()
  const {
    createdAt,
    lineItems,
    liffUser: { linePicture, lineDisplayName },
  } = globalCart

  return (
    <UserLineItems className="user-line-items" noPadding={noPadding} noBorderTop={noBorderTop}>
      <LineItemsHeader>
        <BatchTime>{displayTimeByLang(createdAt, language)}</BatchTime>
        <Profile imageUrl={linePicture} name={lineDisplayName} size="30px" />
      </LineItemsHeader>
      <GlobalCartItemList lineItems={lineItems} buffetPackageName={buffetPackageName} />
    </UserLineItems>
  )
}

export default GlobalCartLineItem

const UserLineItems = styled.div<{ noPadding?: boolean; noBorderTop?: boolean }>`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  padding-bottom: ${({ theme }) => theme.spacing.XL};
  padding-top: ${({ theme }) => theme.spacing.XL};
  border-top: 0.5px solid ${({ theme }) => theme.colors.baseGrey};

  ${({ noPadding }) =>
    noPadding &&
    `
    padding-bottom: 0;
    padding-top: 0;
  `}

  ${({ noBorderTop }) =>
    noBorderTop &&
    `
    border-top: none;
  `}

  .user-line-items-take-away-wrapper + &,
  :first-child {
    border-top: none;
  }
`

const LineItemsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const BatchTime = styled(Fonts.SmallTitleRegular)`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.darkGrey};
`
